import { render } from "./StatsButton.vue?vue&type=template&id=75e14ad2&scoped=true"
const script = {}

import "./StatsButton.vue?vue&type=style&index=0&id=75e14ad2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75e14ad2"]])

export default __exports__